import { render, staticRenderFns } from "./InstallPC.vue?vue&type=template&id=86d5cb80&scoped=true&"
import script from "./InstallPC.vue?vue&type=script&lang=js&"
export * from "./InstallPC.vue?vue&type=script&lang=js&"
import style0 from "./InstallPC.vue?vue&type=style&index=0&id=86d5cb80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d5cb80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d5cb80')) {
      api.createRecord('86d5cb80', component.options)
    } else {
      api.reload('86d5cb80', component.options)
    }
    module.hot.accept("./InstallPC.vue?vue&type=template&id=86d5cb80&scoped=true&", function () {
      api.rerender('86d5cb80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/welfareCenter/InstallPC.vue"
export default component.exports